import React, { useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showFormattedDate } from "../../../../Utils";
import { Button } from "../../../../shared/Button/Button";
import { updateTimeTracking } from "../../../../Actions/BusinessInsights/businessInsightActions";
import { uiNotification } from "../../../../services/UINotificationService";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import styles from "./ClockData.module.scss";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";

const ClockOutData = ({ detail, updateTimeTracking, userPrivileges }) => {
  const [editClockOut, setEditClockOut] = useState({});
  const [selectedDate, setSelectedDate] = useState(detail.clock_out);
  const [isLoading, setIsLoading] = useState(false);

  const { tCommon } = useAppTranslation.Common();

  const editClockOutAvailable =
    moment(new Date()).diff(moment(detail.clock_out), "days") <= 14 &&
    userPrivileges.indexOf("edit-time-card") > -1;

  const clockOutMinDate = new Date(
    new Date().setFullYear(
      moment(detail.clock_in).year(),
      moment(detail.clock_in).month(),
      moment(detail.clock_in).date(),
    ),
  );

  const clockOutMinTime = moment(selectedDate).isSame(
    moment(detail.clock_in),
    "days",
  )
    ? new Date(
        new Date().setHours(
          moment(detail.clock_in).hours(),
          moment(detail.clock_in).minutes() + 1,
          0,
          0,
        ),
      )
    : new Date(new Date().setHours(0, 0, 0, 0));

  const clockOutMaxTime = moment(detail.clock_in).isSame(
    moment(selectedDate),
    "days",
  )
    ? new Date(new Date().setHours(23, 59, 0, 0))
    : new Date(
        new Date().setHours(
          moment(detail.clock_in).hours(),
          moment(detail.clock_in).minutes(),
          0,
          0,
        ),
      );
  const clockOutMaxDate = new Date(
    new Date().setFullYear(
      moment(detail.clock_in).add(1, "day").year(),
      moment(detail.clock_in).add(1, "day").month(),
      moment(detail.clock_in).add(1, "day").date(),
    ),
  );

  const handleEditClockOut = (date) => {
    const languageData = JSON.parse(localStorage.getItem("languageData"));
    const newDate = moment(date).format("YYYY-MM-DD HH:mm:ss");

    setIsLoading(true);

    updateTimeTracking(detail.id, {
      clock_out: newDate,
      clock_in: detail.clock_in,
    })
      .then((res) => {
        uiNotification.success(
          languageData.global[res.message] || "Edited Successfully",
        );
        setEditClockOut({});
      })
      .catch((res) => {
        uiNotification.error(
          languageData.global[res.message] ||
            tCommon(`apiError.${res.message}`, "Unable To Edit"),
        );
      })
      .finally(() => setIsLoading(false));
  };

  return editClockOut.id === detail.id ? (
    <>
      <DatePicker
        selected={new Date(moment(selectedDate).format())}
        onChange={(date) => setSelectedDate(date)}
        showTimeSelect
        timeIntervals={1}
        timeFormat="hh:mm aa"
        dateFormat="MM/dd/yyyy hh:mm aa"
        minDate={clockOutMinDate}
        minTime={clockOutMinTime}
        maxTime={clockOutMaxTime}
        maxDate={clockOutMaxDate}
        className="time-edit-datepicker"
        open
        calendarContainer={({ className, children }) => (
          <div className={styles.calendarContainer}>
            <div className={className}>{children}</div>
            <div className={styles.calendarButtons}>
              <Button
                size="tiny"
                onClick={() => setEditClockOut({})}
                isDisabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                size="tiny"
                onClick={() => handleEditClockOut(selectedDate)}
                leftAdornment={
                  isLoading ? (
                    <CircularProgress size="small" color="white" />
                  ) : null
                }
                isDisabled={isLoading}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      />
    </>
  ) : (
    <div className="flex items-center gap-8">
      {showFormattedDate(detail.clock_out, true, "", "YYYY-MM-DD HH:mm:ss")}
      {editClockOutAvailable && (
        <Button
          size="tiny"
          variant="text"
          onClick={() => {
            setEditClockOut(detail);
          }}
        >
          <i className="fa fa-pencil-alt"></i>
        </Button>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateTimeTracking: updateTimeTracking,
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(ClockOutData);
